import React, { useState } from 'react';
import Icon from './Icon';

const CIRCUIT_IMAGES = {
  'Australia':      'Australia',
  'China':          'China',
  'Japan':          'Japan',
  'Bahrain':        'Bahrain',
  'Saudi Arabia':   'Saudi_Arabia',
  'Miami':          'Miami',
  'Emilia Romagna': 'Emilia_Romagna',
  'Monaco':         'Monaco',
  'Spain':          'Spain',
  'Canada':         'Canada',
  'Austria':        'Austria',
  'Great Britain':  'Great_Britain',
  'United Kingdom': 'Great_Britain',
  'Hungary':        'Hungary',
  'Belgium':        'Belgium',
  'Netherlands':    'Netherlands',
  'Italy':          'Italy',
  'Azerbaijan':     'Azerbaijan',
  'Singapore':      'Singapore',
  'United States':  'USA',
  'Mexico':         'Mexico',
  'Brazil':         'Brazil',
  'Las Vegas':      'Las_Vegas',
  'Qatar':          'Qatar',
  'Abu Dhabi':      'Abu_Dhabi',
};

export const getCircuitImageUrl = (country, circuitName) => {
  const key = Object.keys(CIRCUIT_IMAGES).find(
    k => country?.includes(k) || k.includes(country) ||
         circuitName?.includes(k) || k.includes(circuitName)
  );
  if (!key) return null;
  const name = CIRCUIT_IMAGES[key];
  return `https://media.formula1.com/image/upload/f_auto,c_limit,q_75,w_1320/content/dam/fom-website/2018-redesign-assets/Circuit%20maps%2016x9/${name}_Circuit.png`;
};

const CircuitMap = ({ circuit, className = '', showLabel = true }) => {
  const [failed, setFailed] = useState(false);
  const url = getCircuitImageUrl(circuit?.country, circuit?.circuitName);

  if (!url || failed) {
    return (
      <div className={`flex items-center justify-center bg-zinc-900 border border-zinc-800 rounded-xl ${className}`}>
        <div className="text-center p-6">
          <div className="mb-2 flex justify-center"><Icon name="flag" size={32} className="text-zinc-600" /></div>
          <p className="text-zinc-500 text-sm">{circuit?.circuitName || 'Circuit'}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`relative overflow-hidden rounded-xl bg-zinc-900 border border-zinc-800 ${className}`}>
      <img
        src={url}
        alt={`${circuit?.circuitName} circuit map`}
        className="w-full h-full object-contain p-4"
        onError={() => setFailed(true)}
      />
      {showLabel && (
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-zinc-950/90 to-transparent p-3">
          <p className="text-white font-bold text-sm">{circuit?.circuitName}</p>
          <p className="text-zinc-400 text-xs">{circuit?.locality} · {circuit?.country}</p>
        </div>
      )}
    </div>
  );
};

export default CircuitMap;
